module.exports = __webpack_public_path__ + "media/images/logo-icon-white-1a2deecc355bb9db2ce84903787deeaa.png";